import {makeColumnsSelectorControl} from '../../controls/columns-selector-control/columns-selector-control';
import {columnsSelectorDescriptor} from '../../controls/columns-selector-control/columns-selector-control-descriptors';
import {makeIconButtonControl} from '../../controls/icon-button-control/icon-button-control';
import {ICON_BUTTON_CONTROL_ACTIONS} from '../../controls/icon-button-control/icon-button-control.types';
import {makeOptionListControl} from '../../controls/option-list-control/option-list-control';
import {verticalAlignDescriptor} from '../../controls/option-list-control/option-list-control-descriptors';
import {makeSliderControl} from '../../controls/slider-control/slider-control';
import {borderRadiusDescriptor, columnSpacingDescriptor, paddingDescriptor} from '../../controls/slider-control/slider-control-descriptors';
import {makeStyleHeader} from '../../controls/style-header/style-header';
import {makeUploadButtonControl} from '../../controls/upload-button-control/upload-button-control';
import {backgroundMediaDescriptor} from '../../controls/upload-button-control/upload-button-control-descriptors';
import {isSectionOrTableComponent, registerEmailMakerSector} from '../../right-panel-registry';
import {TileComplexity} from '@EmailMakerReact/lib/email-maker-tile-meta-library.types';
import {deleteControl, duplicateControl, lockControl} from '../shared/common-action-controls';
import {borderStyleControl, conditionalBorderColorControl, conditionalBorderWidthControl} from '../shared/border-controls';
import {bgColorControl} from '../shared/color-controls';
import type {EmailMakerControl, EmailMakerSectorProperty} from '../../right-panel-registry.types';

const saveControl = makeIconButtonControl({action: ICON_BUTTON_CONTROL_ACTIONS.SAVE, labelKey: 'pmwjs_save', iconClass: 'icon-save'});

const layoutHeader: EmailMakerControl = makeStyleHeader('pmwjs_layout');
const stylesHeader: EmailMakerControl = makeStyleHeader('pmwjs_styles');

const columnsSelectorControl = makeColumnsSelectorControl(columnsSelectorDescriptor);
const backgroundMediaControl: EmailMakerControl = makeUploadButtonControl(backgroundMediaDescriptor);

const verticalAlignControl = makeOptionListControl(verticalAlignDescriptor);

const borderRadiusControl = makeSliderControl(borderRadiusDescriptor);
const columnSpacingControl = makeSliderControl(columnSpacingDescriptor);
const paddingControl = makeSliderControl(paddingDescriptor);

const SECTION_PROPERTIES: readonly EmailMakerSectorProperty[] = [
  {control: saveControl},
  {control: duplicateControl},
  {control: lockControl},
  {control: deleteControl},
  {control: layoutHeader},
  {control: columnsSelectorControl, tileMeta: {icon: 'icon-table', labelKey: 'pmwjs_columns', complexity: TileComplexity.SIMPLE}},
  {control: stylesHeader},
  {control: backgroundMediaControl, tileMeta: {icon: 'icon-image', labelKey: 'pmwjs_background_media', complexity: TileComplexity.SIMPLE}},
  {control: bgColorControl, tileMeta: {icon: 'icon-fill', labelKey: 'pmwjs_background_color', complexity: TileComplexity.SIMPLE}},
  {control: verticalAlignControl, tileMeta: {icon: 'icon-v-align-center', labelKey: 'pmwjs_vertical_alignment', complexity: TileComplexity.SIMPLE}},
  {control: borderStyleControl, tileMeta: {icon: 'icon-stroke', labelKey: 'pmwjs_border', complexity: TileComplexity.SIMPLE}},
  {control: conditionalBorderColorControl, tileMeta: {icon: 'icon-colorpicker', labelKey: 'pmwjs_border_color', complexity: TileComplexity.SIMPLE}},
  {control: conditionalBorderWidthControl, tileMeta: {icon: 'icon-stroke', labelKey: 'pmwjs_thickness', complexity: TileComplexity.SIMPLE}},
  {control: borderRadiusControl, tileMeta: {icon: 'icon-corner', labelKey: 'pmwjs_roundness', complexity: TileComplexity.COMPLEX}},
  {control: columnSpacingControl, tileMeta: {icon: 'icon-equal-spacing-horizontal', labelKey: 'pmwjs_gap', complexity: TileComplexity.SIMPLE}},
  {control: paddingControl, tileMeta: {icon: 'icon-edge-spacing', labelKey: 'pmwjs_spacing', complexity: TileComplexity.COMPLEX}},
];

registerEmailMakerSector((component) => isSectionOrTableComponent(component), {
  title: window.i18next.t('pmwjs_section'),
  properties: SECTION_PROPERTIES,
});
